import * as React from 'react'
import * as css from './HvacChecklistForm.module.css'
import { useForm } from 'react-hubspot'
import slugify from 'slugify'
import { navigate } from 'gatsby'

function redirectAfterDelay(url) {
	setTimeout(() => {
		navigate(url)
	}, 3000)
}

const HvacChecklistForm = ({ title, portalId, formId, submitButton }) => {
	const { data, isLoading, isError, handleSubmit } = useForm({
		portalId,
		formId,
	})

	const email = React.useRef(null)

	const id = title ? slugify(title, { lower: true }) : 'form'

	return (
		<>
			<form id={id} className={css.form} onSubmit={handleSubmit}>
				{/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
				<label htmlFor="email-input">
					<input
						ref={email}
						onChange={(e) => (email.current = e)}
						className={`${css.input} input`}
						id="email-input"
						name="email"
						type="email"
						inputMode="email"
						placeholder="Email"
					/>
				</label>

				<button className={`${css.btn} action lg`}>{submitButton || 'Submit'} ➞</button>
			</form>

			{isLoading ? (
				<div className={css.msg}>Sending...</div>
			) : isError ? (
				<div className={css.msg}>An error occurred. Please enter a valid email address</div>
			) : (
				data && (
					<div className={`${css.msg} richtext`}>
						{data.statusText === 'OK' && <p>Successfully submitted!</p>}
						{data.data.inlineMessage && <p>{data.data.inlineMessage}</p>}

						{data.data?.redirectUri && (
							<>
								<p>Redirecting to download page...</p>
								{redirectAfterDelay(data.data.redirectUri)}
							</>
						)}
					</div>
				)
			)}
		</>
	)
}

export default HvacChecklistForm
